import { PropsWithChildren, forwardRef, useImperativeHandle } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { investee as Investee } from 'further-ui/validations';
import { zodResolver } from '@hookform/resolvers/zod';

type Props = {
  values: Investee.NewCompanyFormValues | Investee.NewShareClassFormValues;
};

export type FormWrapperRef = {
  reset: () => void;
};

const FormWrapper = forwardRef<FormWrapperRef, PropsWithChildren<Props>>(
  ({ children, values }, ref) => {
    const schema = Investee.getInvesteeFormSchema(values.isNewCompany);
    const formMethods = useForm<
      Investee.NewCompanyFormValues | Investee.NewShareClassFormValues
    >({
      shouldFocusError: true,
      resolver: zodResolver(schema),
      defaultValues: values,
      criteriaMode: 'all',
      reValidateMode: 'onChange',
    });

    useImperativeHandle(ref, () => ({
      reset: () => formMethods.reset(values),
    }));

    return <FormProvider {...formMethods}>{children}</FormProvider>;
  },
);

FormWrapper.displayName = 'FormWrapper';

export default FormWrapper;
